import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import {
  CreateViewRequest,
  CreateViewResponse,
  DeleteViewRequest,
  DeleteViewResponse,
  InitAlertsRequest,
  UpdateActiveViewRequest,
  UpdateActiveViewResponse,
  UpdateSmartViewsStateResponse,
  UpdateSmartViewsStateRequest,
  UpdateViewPropsRequest,
  UpdateViewPropsResponse,
  ValidateViewNameRequest,
  ValidateViewNameResponse,
} from '@nirvana/shared/dtos/types/alerts/gz-console';
import {
  GetAllColumnDetailsRequest,
  GetAllColumnDetailsResponse,
  InitAlertsResponse,
} from '@nirvana/shared/dtos/types/alerts/common';

export class AlertsBaseDataProvider extends BaseWebComponentDataProvider {
  async initAlerts(request: InitAlertsRequest): Promise<InitAlertsResponse> {
    throw new Error('Not implemented');
  }

  async getAllColumnDetails(params: GetAllColumnDetailsRequest): Promise<GetAllColumnDetailsResponse> {
    throw new Error('Not implemented');
  }

  public deleteView(params: DeleteViewRequest): Promise<DeleteViewResponse> {
    throw new Error('Not implemented');
  }

  public createView(params: CreateViewRequest): Promise<CreateViewResponse> {
    throw new Error('Not implemented');
  }

  public updateActiveView(params: UpdateActiveViewRequest): Promise<UpdateActiveViewResponse> {
    throw new Error('Not implemented');
  }

  public updateViewProps(params: UpdateViewPropsRequest): Promise<UpdateViewPropsResponse> {
    throw new Error('Not implemented');
  }

  public validateViewName(params: ValidateViewNameRequest): Promise<ValidateViewNameResponse> {
    throw new Error('Not implemented');
  }

  public updateSmartViewsState(params: UpdateSmartViewsStateRequest): Promise<UpdateSmartViewsStateResponse> {
    throw new Error('Not implemented');
  }
}
